import { Injectable } from '@angular/core';

import { AuthService } from './auth.service';
import { Enums, IEnums } from 'app/app.enums';

@Injectable({ providedIn: 'root' })
export class AuthorizationService {
  enums: IEnums = Enums;

  constructor(private authService: AuthService) {}

  isShiftAdmin(): boolean {
    return this.isInRole(this.enums.role.shiftAdmin);
  }

  isShiftAnalyst(): boolean {
    return this.isInRole(this.enums.role.shiftAnalyst);
  }

  isRetaileruser(): boolean {
    return this.isInRole(this.enums.role.retailerManager) || this.isInRole(this.enums.role.retailerRepresentative);
  }

  isInRole(roleName: string): boolean {
    return this.hasAnyRole([roleName]);
  }

  hasAnyRole(_roles: string[]): boolean {
    const currentUser = this.authService.getCurrentUser();
    return (currentUser?.roles?.length ?? 0) > 0;
  }

  canSeeEverything(): boolean {
    return this.hasAnyRole([this.enums.role.shiftAdmin, this.enums.role.shiftAnalyst, this.enums.role.corporate]);
  }
}
